export const styles = (theme) => ({

    root: {
        flexGrow: 1,
         margin: 20, 
      },
});

export default styles;
